<template>
	<div>
		<div class="row">
			<div class="col-12">
				<h2>My Details</h2>
			</div>
		</div>
		<div class="row">
			<div class="col-md-6">
				<InputText id="first_name" name="First Name" :form="userForm" :errors="userErrors"/>
			</div>
			<div class="col-md-6">
				<InputText id="last_name" name="Last Name" :form="userForm" :errors="userErrors"/>
			</div>
		</div>
		<div class="row">
			<div class="col-md-6">
				<InputText id="email" name="Email Address" :form="userForm" :errors="userErrors"/>
			</div>
			<div class="col-md-6">
				<InputText id="phone" name="Phone Number" :form="userForm" :errors="userErrors"/>
			</div>
		</div>
		<hr>
		<div class="row">
			<div class="col-12">
				<h2>Company Details</h2>
			</div>
		</div>
		<div class="row">
			<div class="col-md-6">
				<InputText id="company_name" name="Company Name" :form="tenantForm" :errors="tenantErrors"/>
			</div>
			<div class="col-md-6">
				<ImageUpload id="logo" name="Upload Logo" :form="tenantForm" :errors="tenantErrors"/>
			</div>
		</div>
		<div class="row">
			<div class="col-md-6">
				<InputText id="address_line_1" name="Address line 1" :form="tenantForm" :errors="tenantErrors"/>
			</div>
			<div class="col-md-6">
				<InputText id="address_line_2" name="Address line 2" :form="tenantForm" :errors="tenantErrors"/>
			</div>
		</div>
		<div class="row">
			<div class="col-md-6">
				<InputText id="city" name="Town / City" :form="tenantForm" :errors="tenantErrors"/>
			</div>
			<div class="col-md-6">
				<InputText id="county" name="County" :form="tenantForm" :errors="tenantErrors"/>
			</div>
		</div>
		<div class="row">
			<div class="col-md-6">
				<InputText id="postcode" name="Postcode" :form="tenantForm" :errors="tenantErrors"/>
			</div>
			<div class="col-md-6">
				<InputSelect id="country_code" name="Country" optionKey="code" :options="countries" label="name" :form="tenantForm" :errors="tenantErrors"/>
			</div>
		</div>
		<div class="row">
			<div class="col-md-6">
				<InputNumber id="pin" name="Access Pin" :form="tenantForm" :errors="tenantErrors" maxLength="4"/>
			</div>
		</div>
		<hr>
		<div class="row">
			<div class="col-12 subscription-container text-center">
				<h2>Subscription</h2>
				<div class="trial" v-if="trialDaysLeft > 0">
					<span><i class="ss-alert"></i>You are currently on a 'free' subscription which expires in </span>
					<span class="days-left">{{ trialDaysLeft }} days</span>
				</div>
				<div class="row subscription">
					<div class="col-12">
						<div class="row">
							<div class="col-4">
								<h3>Max Horses</h3>
								<span>{{ account.tenant.max_horses >= 9999 ? 'Unlimited' : account.tenant.max_horses }}</span>
							</div>
							<div class="col-4">
								<h3>Location Add on</h3>
								<span>{{ account.tenant.has_multi_yard == 0 ? 'Not Owned' : 'Owned' }}</span>
							</div>
							<div class="col-4">
								<h3>Price</h3>
								<span>£{{ account.tenant.monthly_payment }}</span>
							</div>
						</div>
						<div class="row update-subscription">
							<div class="col-lg-6">
								<button v-if="account.tenant.max_horses < 9999" @click="$emit('upgrade')" class="upgrade-button">Upgrade Subscription</button>
								<p>Want to downgrade? <a :href="updateContactUrl" target="_blank">Contact us</a></p>
							</div>
							<div class="col-lg-6">
								<button v-if="account.tenant.subscription_expired == null" @click="$emit('cancel')" class="cancel-button">Cancel Subscription</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-12 text-right">
				<hr>
				<button class="button-action save-account" @click="save">Save Changes</button>
			</div>
		</div>
	</div>
</template>

<script>
import InputText from '../Form/InputText.vue'
import InputNumber from '../Form/InputNumber.vue'
import InputCheckbox from '../Form/InputCheckbox.vue'
import InputSelect from '../Form/InputSelect.vue'
import ImageUpload from '../Form/ImageUpload.vue'
import { mapState } from 'vuex'
import moment from 'moment';

export default {
	components: {
		InputText,
		InputNumber,
		InputCheckbox,
		InputSelect,
		ImageUpload
	},
	props: [
		'account'
	],
	data() {
		return {
			userForm: {},
			userErrors: {},
			tenantForm: {},
			tenantErrors: {},
			userRequiredFields: ['first_name', 'last_name', 'email'],
			tenantRequiredFields: ['company_name', 'address_line_1', 'city', 'county', 'postcode', 'country_code', 'pin'],
		}
	},
	computed: {
		...mapState({
			countries: state => state.countries
		}),
		trialDaysLeft() {
			if(this.account && this.account.tenant && this.account.tenant.trial_end_date) {
				const today = moment()
				const trialEndDate = moment(this.account.tenant.trial_end_date)

				return trialEndDate.diff(today, 'days')
			}
			return 0
		},
		updateContactUrl() {
			if(this.userForm && this.tenantForm) {
				return `https://yardonline.dev/contact-us?` +
				`firstName=${this.userForm.first_name}` +
				`&lastName=${this.userForm.last_name ? this.userForm.last_name : '' }` +
				`&email=${this.userForm.email ? this.userForm.email : '' }` +
				`&company=${this.tenantForm.company_name ? this.tenantForm.company_name : '' }` +
				`&phone=${this.userForm.phone ? this.userForm.phone : '' }`
			} else {
				return 'https://yardonline.dev/contact-us'
			}
		}
	},
	methods: {
		formIsValid() {
			let validForm = true
			
			this.userErrors = {}
			this.tenantErrors = {}

			this.userRequiredFields.forEach(field => {
				if(!this.userForm.hasOwnProperty(field) || this.userForm[field] == '') {
					this.userErrors[field] = 'This field is required.'
					validForm = false
				}
			})

			this.tenantRequiredFields.forEach(field => {
				if(!this.tenantForm.hasOwnProperty(field) || this.tenantForm[field] == '') {
					this.tenantErrors[field] = 'This field is required.'
					validForm = false
				}
			})

			return validForm
		},
		save() {
			if(!this.formIsValid()) {
				this.$store.dispatch('app/addAlert', {
					type: 'error',
					message: 'Form error - please check and re-submit',
					timeout: 3000
				})
				return
			}
			const self = this
			this.$store.commit('app/setLoading', true)
			this.$store.dispatch('account/update', { user: this.userForm, tenant: this.tenantForm })
			.then(() => {
				//rebuild tenant in case something has changed
				const tenant = { 
					id: self.account.tenant.id,
					companyName: self.tenantForm.company_name,
					hasMultiYard: self.account.tenant.has_multi_yard,
					maxHorses: self.account.tenant.max_horses,
					subscriptionExpired: self.account.tenant.subscription_expired,
					trialEndDate: self.account.tenant.trial_end_date,
					logo: self.tenantForm.logo
				}
				this.$store.commit('tenant/set', tenant);
				this.$store.commit('app/setLoading', false);
				this.$store.dispatch('app/addAlert', {
					type: 'success',
					message: 'Account updated',
					timeout: 3000
				})
			})
			.catch(err => {
				this.$store.commit('app/setLoading', false);
				this.$store.dispatch('app/addAlert', {
					type: 'error',
					message: 'An Error occurred, please try later',
					timeout: 3000
				})
			})
		}
	},
	mounted() {
		if(this.account) {
			this.userForm = Object.assign({}, this.account.user)
			this.tenantForm = Object.assign({}, this.account.tenant)
		}
	}
}
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Account/Form.vue